import { render } from "./SearchOrdersView.vue?vue&type=template&id=567d4667&ts=true"
import script from "./SearchOrdersView.vue?vue&type=script&lang=ts"
export * from "./SearchOrdersView.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__